import React, { useState, useEffect, useRef } from 'react';
import { FaTimes } from 'react-icons/fa';
import { getRequestItems } from '../../../api/requests';
import { mediaUrl } from '../../../api/client';
import noImageIcon from '../../../images/no-image-icon.svg';
import styles from './RequestItemsModal.module.css';

const RequestItemsModal = ({ onClose, pedido, handleShowCheckList }) => {
    const [items, setItems] = useState([]);
    const [expandedItems, setExpandedItems] = useState({});
    const modalRef = useRef();

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await getRequestItems(pedido.id);
                setItems(response.data);
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };

        fetchItems();
    }, [pedido]);

    const getImageUrl = (imagePath) => mediaUrl(imagePath) || noImageIcon;

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    };

    return (
        <div className={styles.overlay} onClick={handleClickOutside}>
            <div className={styles.container} ref={modalRef}>
                <div className={styles.tableContainer}>
                    <div className={styles.tableHeader}>
                        <h2 className={styles.title}>Ítems</h2>
                        <button className={styles.toggleButton} onClick={onClose}>
                            <FaTimes />
                        </button>
                    </div>
                    <div className={styles.tableBody}>
                        <table className={`bg-white text-center ${styles.itemTable}`}>
                            <thead>
                                <tr>
               
                                </tr>
                            </thead>
                            <tbody>
                                {items.map(item => {
                                    const imageUrl = item.image ? getImageUrl(item.image.image) : noImageIcon;
                                    const expanded = expandedItems[item.id] || false;
                                    const handleExpandClick = () => {
                                        setExpandedItems(prev => ({
                                            ...prev,
                                            [item.id]: !expanded
                                        }));
                                    };
                                    return (
                                        <tr key={item.id} className="item-row">
                                            <td><img src={imageUrl} alt={item.equipo} className="item-image" /></td>
                                            <td>
                                                <div
                                                    className={`${styles.itemDetails}${expanded ? ` ${styles.expanded}` : ''}`}
                                                    style={{ cursor: 'pointer', borderRadius: '8px', padding: '8px', background: '#f7f7f7', boxShadow: expanded ? '0 2px 8px rgba(0,0,0,0.08)' : 'none' }}
                                                    onClick={handleExpandClick}
                                                >
                                                    <p style={{ fontWeight: 'bold', marginBottom: '4px' }}>Nombre: <span style={{ color: '#2c3e50' }}>{item.equipo ? item.equipo : "No Disponible"}</span></p>
                                                    <p style={{ fontWeight: 'bold', marginBottom: expanded ? '8px' : '0' }}>Marca: <span style={{ color: '#2c3e50' }}>{item.marca ? item.marca : "No Disponible"}</span></p>
                                                    {expanded && (
                                                        <div className={styles.itemExtraDetails} style={{ marginTop: '8px', fontSize: '0.97em', color: '#555' }}>
                                                            <p>Descripción: {item.descripcion ? item.descripcion : "No Disponible"}</p>
                                                            <p>Estado: {item.estado ? item.estado : "No Disponible"}</p>
                                                            <p>Sección: {item.seccion ? item.seccion : "No Disponible"}</p>
                                                            <p>Fecha Vencimiento: {item.fechaVencimiento ? item.fechaVencimiento : "No Disponible"}</p>
                                                            <p>Observación: {item.observacion ? item.observacion : "No Disponible"}</p>
                                                            <p>Proveedor: {item.proveedor ? item.proveedor : "No Disponible"}</p>
                                                        </div>
                                                    )}
                                                    <div style={{ textAlign: 'right', marginTop: '4px' }}>
                                                        <span style={{ fontSize: '0.9em', color: '#2980b9' }}>{expanded ? '▲ Ocultar detalles' : '▼ Ver más detalles'}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className={styles.quantity}>
                                                    <span className={styles.unitText}>{item.cantidad}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className={styles.tableFooter}>
                        <button className={styles.checklistButton} onClick={() => handleShowCheckList(pedido)}>
                            Mostrar Checklist
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RequestItemsModal;